import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RWAOfficeSpaceEnt } from '../../../model/FormsEntity/RwaOfficeSpaceEnt';
import { MatTableDataSource } from '@angular/material/table';
import { RWAService } from '../../../service/rwa.service';
import { AuthenticationService } from '../../../service/authentication.service';
import { RWARegistrationEnt } from '../../../model/FormsEntity/RwaRegistrationEnt';
import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../core/core.module';
import { FormGroup, FormControl } from '@angular/forms';
import { RegistrationAppResponse } from '../../../model/FormsEntity/RegistrationAppResponse.model';

@Component({
  selector: 'dda-rwa-reg-publish-form',
  templateUrl: './rwa-reg-publish-form.component.html',
  styleUrls: ['./rwa-reg-publish-form.component.scss'],
})
export class RwaRegPublishFormComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  applicationFormList:MatTableDataSource<RWAOfficeSpaceEnt>;
  displayedColumns:string[] = ['id','applicantName','applicationDate','nameOfRWA','nameOfColony','lastDateToFileObjection','view'];
  applicationFormArray:any;
  userId:number;selectedRowIndex = -1;
  registrationAppResponse: RegistrationAppResponse = new RegistrationAppResponse();
  roleName:String;preShow:boolean=false;secShow:boolean=false;authShow:boolean=false;
  applicationId:string;startDate:Date;endDate:Date;
  showForm:boolean = false;dateSearch:boolean = false;idSearch:boolean = false;statusSearch:boolean = false;
  rwaRegistration:RWARegistrationEnt = new RWARegistrationEnt();
  rwaRegistrationEntity:RWARegistrationEnt = new RWARegistrationEnt();
  user_designation: string;
  constructor(private rwaService:RWAService,private loginService:AuthenticationService) { }
  filterForm = new FormGroup({
    fromDate: new FormControl(),
    toDate: new FormControl(),
  });
  ngOnInit(): void {
    let users = sessionStorage.getItem('currentUser');
    if(users != null){
      const currentUser = this.loginService.currentUserValue;
      const roleElement = currentUser.roles[0];
      this.user_designation = roleElement.name;
     
      this.userId = currentUser.id;
      this.roleName = roleElement.fullName;

      console.log(this.userId);
    }
    this.rwaService.getListRwaRegistrationPublishForm().subscribe(data =>{
      this.applicationFormList = new MatTableDataSource(data);
      console.log(this.applicationFormList);
  });
}
highlight(row: { rwaApp_no: number; }){
  this.selectedRowIndex = row.rwaApp_no;
}
applyFilter(event: Event) {
  const filterValue = (event.target as HTMLInputElement).value;
  this.applicationFormList.filter = filterValue.trim().toLowerCase();
}
searchApplicationByStatus(value){
  alert(value);
  const filterValue = value;
  this.applicationFormList.filter = filterValue.trim().toLowerCase();
}
searchByDate(){
  this.dateSearch = true;
  this.idSearch = false;
  this.statusSearch = false;
}
searchById(){
  this.dateSearch = false;
  this.idSearch = true;
  this.statusSearch = false;
}
searchByStatus(){
  this.dateSearch = false;
  this.idSearch = false;
  this.statusSearch = true;
}
  showView(row){
    this.showForm = true;
    this.rwaRegistration = row;
      if(row.applicantIs != null){
        this.changeApplicant(row.applicantIs);
      }
    
  }
  changeApplicant(value) {
   
    if(value === 1){

      this.preShow = true; 
      this.secShow = false;
    }
    else if(value === 2){
      this.secShow = true;
      this.preShow = false; 
    }
    else{
      this.preShow = false; 
      this.secShow = false;
    }
  }
  applyFilterDate(){
    console.log(this.startDate);
    this.rwaRegistrationEntity.fromDate = this.startDate;
    this.rwaRegistrationEntity.toDate = this.endDate;
    this.rwaRegistrationEntity.createdById = this.userId;
    this.rwaService.dateFilterOnPublishForm(this.rwaRegistrationEntity).subscribe(data =>{
      this.applicationFormList = new MatTableDataSource(data);
      console.log(data);
    });
  }
}
